export const enClientPortalHandoverModal = {
    imageAlt: 'share',
    actions: {
        confirm: 'Share',
    },
    items: {
        requestNewDraft: 'Request a new draft based on the comments',
    },
    infoText: 'You can still add, edit, and delete comments on this draft. Your appraiser will be notified immediately.',
}
